import { render, staticRenderFns } from "./NewOrders.vue?vue&type=template&id=327da976&scoped=true&"
import script from "./NewOrders.vue?vue&type=script&lang=js&"
export * from "./NewOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327da976",
  null
  
)

export default component.exports